/** @format */

export function trackDataLayer(eventName, payload = {}) {
  // ensure dataLayer array exists
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...payload
  });
}
